import { render } from "./CreateProductModal.vue?vue&type=template&id=86809dda&scoped=true"
import script from "./CreateProductModal.vue?vue&type=script&lang=js"
export * from "./CreateProductModal.vue?vue&type=script&lang=js"

import "./CreateProductModal.vue?vue&type=style&index=0&id=86809dda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86809dda"]])

export default __exports__